const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const classNames = require('classnames');
// @ commons
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKIconButton } = require('commonsComponents/OKIconButton');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const OKTableRowDetails = require('components/rebrand/OKTableRowDetails/OKTableRowDetails');
const OKTableRowDetailsItem = require('components/rebrand/OKTableRowDetails/OKTableRowDetailsItem/OKTableRowDetailsItem');
import { recordLinkV2 } from "utilities/tagging";
// @ components
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ actions
const emitedTransfersDetails = require('actions/emitedTransfersDetails');
// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { getIntervenersNames, getSepaType, isSepa } = require('utilities/transfersHelper');

// @Contact Center
const WarningMessage = require('components/contactCenter/warningMessage/warningMessage');

// @ constants
const { getTranslatedCountry } = require('constants/countries');
const { HYPHEN, NONE_SEPA } = require('constants/index');

class EmitedTransfersContentTableInfoRow extends React.Component {
    constructor(props) {
        super(props);
        this.buildLoadingSection = this.buildLoadingSection.bind(this);
        this.buildDetailsSection = this.buildDetailsSection.bind(this);
        this.handleDownloadBtnClick = this.handleDownloadBtnClick.bind(this);
    }

    componentDidMount() {
        const { requestEmitedTransfersDetails, immTransaction } = this.props;
        requestEmitedTransfersDetails(immTransaction);
    }

    buildDetailsSection() {
        const { immTransaction, immScreen } = this.props;
        
        if (!immTransaction.get('details') || immTransaction.get('fetchingDetails')) return null;

        const isMobile = immScreen.get('isMobile');
        const transferInfo = this.transferInfo(isMobile);
        const rowColumns = (isMobile) ? 1 : 2;
        const rowDetailsTitle = (isMobile) ? "" : "transfersEmited-detailInformation";

        const immDetails = immTransaction.get('details');
        const isPsd2Payment = immDetails.get('isPsd2Payment');

        if(__CONTACT_CENTER__ && isPsd2Payment) {
            recordLinkV2({
                categoriaEvento:"transferencias/emitidas",
                accionEvento:"visualizacion mensaje",
                etiquetaEvento:"no se puede anular desde cc"
            })
        }

        return (
            <div>
                <OKTableRowDetails
                    columns={rowColumns}
                    isMobile={isMobile}
                    title={rowDetailsTitle}
                    >
                    {transferInfo}
                </OKTableRowDetails>
                {
                    __CONTACT_CENTER__ && isPsd2Payment &&
                    <div>
                        <WarningMessage
                            isLink={false}
                            text={<FormattedText value="cc_operatives-doNotCancelTransferInfo" />}
                            to={"warningLink"}
                            visible={true}
                            typeOfBackground="orange"
                        />
                    </div>
                }
            </div>
        );
    }

    buildLoadingSection() {
        if (this.props.immTransaction.get('fetchingDetails')) {
            return <LoadingSection />;
        }
    }

    buildPdfButtonSection() {
        const { immTransaction } = this.props;
        const isInsideSepa = isSepa(immTransaction.get('country'), immTransaction.getIn(['amount', 'currency'])) && (immTransaction.get('transferType') !== 'HH');
        let buttonSection;

        if (isInsideSepa) {
            const button = (
                <div className="transfers-table-info-row__button-container">
                    <OKIconButton icon="icon-descargar" onClick={this.handleDownloadBtnClick} />
                </div>
            );

            buttonSection = (
                <OKTooltip
                    content="transfersEmited-receiptDownload"
                    offset={[0, -15]}
                    target={button}
                    type="descriptive"
                />
            );
        }

        return buttonSection;
    }

    buildLiquidationButtonSection() {
        const { immTransaction } = this.props;
        const isNoSepa = (immTransaction.get('transferType') === 'HH') || getSepaType(immTransaction.get('country'), immTransaction.getIn(['amount', 'currency'])) === NONE_SEPA;
        let buttonSection;

        if (isNoSepa) {
            const accountId = immTransaction.get('accountId');
            const transferId = immTransaction.get('id');
            const liquidationsPath = `/myprofile/transfers/transfer/liquidation-details/${accountId}/${transferId}`;

            buttonSection = (
                <div className="transfers-table-info-row__details-button">
                    <OKButton
                        modifier="secondary"
                        to={liquidationsPath}
                    >
                        <FormattedText value="transfersEmited-showLiquidationDetails" />
                    </OKButton>
                </div>
            );
        }

        return buttonSection;
    }

    buildFooterSection() {
        const {
            immTransaction,
            immScreen,
        } = this.props;

        const buttonPdfSection = this.buildPdfButtonSection();
        const buttonLiquidationSection = this.buildLiquidationButtonSection();

        let footerSection;
        const footerClasses = classNames({
            'transfers-table-info-row__footer' : !immScreen.get('isMobile'),
        });

        if (!immTransaction.get('fetchingDetails') && !immTransaction.get('error')) {
            footerSection = (
                <footer className={footerClasses}>
                    {buttonPdfSection}
                    {buttonLiquidationSection}
                </footer>
            );
        }

        return footerSection;
    }

    handleDownloadBtnClick() {
        const {
            emitedTransfersGetPdf,
            immTransaction
        } = this.props;
        // For some reason, when the request fails it doesn't run the catch that sets
        // fetchingPdf to false in emitedTransfersDetails.js. The failure is due to the
        // arraybuffer responseType of the request, but it can't be deleted or the .pdf breaks
        emitedTransfersGetPdf(immTransaction, formatText('transfersEmited-receiptFileName'));
    }

    transferInfo(isMobile) {
        const {
            immAccounts,
            immTransaction
        } = this.props;

        const immDetails = immTransaction.get('details');
        const country = immTransaction.get('country');
        const accountId = immTransaction.get('accountId');
        const immInterveners = immAccounts.getIn(['byId', accountId, 'interveners', 'list']);
        const immEmitter = immTransaction.get('emitter');
        const immPayer = immTransaction.get('payer');
        const intervenersNames = getIntervenersNames(immInterveners, immPayer, immEmitter);
        const isPsd2Payment = immDetails.get('isPsd2Payment')
        const items = [
            {
                label: formatText('transfersEmited-beneficiaryAccount'),
                value: immDetails.get('abonoIban') || immDetails.get('accountNumber') || HYPHEN
            },
            {
                label: formatText('transfersEmited-beneficiary'),
                value: immDetails.get('beneficiary') || HYPHEN
            },
            {
                label: formatText('transfersEmited-referenceNumber'),
                value: immTransaction.getIn(['reference', 'numerodeorden'])
            },
            {
                label: formatText('transfersEmited-transferCost'),
                value: <FormattedText value="transfersEmited-transferCost" apiValue={immDetails.get('transferExpenses')} />
            },
            {
                label: formatText('transfersEmited-concept'),
                value: immDetails.get('concept') || HYPHEN
            },
            {
                label: formatText('transfersEmited-transferType'),
                value: <FormattedText value="transfersEmited-transferType" apiValue={immDetails.get('transferType')} />
            },
        ];

        if(__CONTACT_CENTER__ && isPsd2Payment) {
            items.push( {
                label: formatText('cc_operatives-transferDoneByTPP'),
                value: formatText('cc_operatives-doNotCancelTransferTitle') 
            })
        }
     
        //If mobile remove fields with value immDetails.get('beneficiary') and immDetails.get('concept')
        if (isMobile) {
            items.splice(1, 1);
            items.splice(3, 1);
        }

        if (!!intervenersNames.payerName) {
            items.splice(0, 0,
                {
                    label: formatText('transferSummary-step2TransferEmitter'),
                    value: intervenersNames.payerName
                }
            );
            items.splice(2, 0,
                {
                    label: formatText('transferSummary-step2TransferPayer'),
                    value: intervenersNames.emitterName || immDetails.get('payer') || HYPHEN
                }
            );
        } else {
            items.splice(0, 0,
                {
                    label: formatText('transferSummary-step2TransferPayer'),
                    value: intervenersNames.emitterName || immDetails.get('payer') || HYPHEN
                }
            );
        }

        if (country !== 'ES') {
            items.splice(3, 0, {
                label: formatText('transfersEmited-country'),
                value: getTranslatedCountry(country)
            });
        }

        return items.map(({ label, value }, index) => (
            <OKTableRowDetailsItem
                key={`firstColumnTransferInfo-${index}`}
                title={label}
                value={value}
            />
        ));
    }

    render() {
        const detailsSection = this.buildDetailsSection();
        const loadingSection = this.buildLoadingSection();
        const footerSection = this.buildFooterSection();

        return (
            <OKTableRow id={this.props.id}>
                <OKTableCell />
                <OKTableCell colSpan={5}>
                    {loadingSection}
                    {detailsSection}
                    {footerSection}
                </OKTableCell>
                <OKTableCell />
            </OKTableRow>
        );
    }
}

EmitedTransfersContentTableInfoRow.propTypes = {
    emitedTransfersGetPdf: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    immTransaction: PropTypes.object.isRequired,
    requestEmitedTransfersDetails: PropTypes.func.isRequired
};

module.exports.constructor = EmitedTransfersContentTableInfoRow;
module.exports.EmitedTransfersContentTableInfoRow = connect(
    state => ({
        immAccounts: state.accounts,
        immScreen: state.screen,
    }),
    {
    emitedTransfersGetPdf: emitedTransfersDetails.emitedTransfersGetPdf,
    requestEmitedTransfersDetails: emitedTransfersDetails.requestEmitedTransfersDetails
})(EmitedTransfersContentTableInfoRow);
